import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { Account } from './Account'
import { AccountUsers } from './AccountUsers'
import { AccountNotificationPreferences } from './AccountNotificationPreferences'
import { AccountReferrals } from './AccountReferrals'
import { WithACL } from '../../auth/WithACL'
import { AccountProfile } from './account-profile/AccountProfile'

export const AccountRoutes = ({ account, showProfile, onAccountUpdated }) => {
  const location = useLocation()

  if (location.pathname === '/account') return <Account account={account} />
  if (location.pathname === '/account/users')
    return (
      <WithACL
        success={
          <AccountUsers account={account} onAccountUpdated={onAccountUpdated} />
        }
        conditionMet={account.isInstitution}
        redirectTo={'/account'}
      />
    )
  if (location.pathname === '/account/notifications')
    return <AccountNotificationPreferences account={account} />
  if (location.pathname === '/account/referrals')
    return <AccountReferrals account={account} />
  if (location.pathname === '/account/profile')
    return (
      <WithACL
        success={<AccountProfile account={account} />}
        conditionMet={showProfile}
        redirectTo={'/account'}
      />
    )
  else {
    return <Redirect to='/' />
  }
}
